<template>
  <div>
    <TransferAccountMain />
  </div>
</template>

<script>
import TransferAccountMain from "../components/transferAccount/TransferAccountMain.vue";

export default {
  name: "TransferAccountListView",
  components: { TransferAccountMain },
};
</script>
